import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24.946}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 46644 48055"
    {...props}
  >
    <path
      d="M45327 46738h-94c-1452 0-2633-1181-2633-2633V32256c0-1452 1181-2633 2633-2633h94v17115zM1701 21723l9718-20406h19857l9717 20406H1701zm11465 12507h-1317v-5266h1317v5266zm32819-5924h-752c-2178 0-3949 1772-3949 3950v5266H26614c-2542 0-4608-2067-4608-4608v-9874h20030c226 0 436-115 557-306 120-192 135-432 38-635L32286 376c-109-230-341-376-594-376H11002c-253 0-484 146-594 376L64 22099c-97 203-82 443 38 635 121 191 330 306 557 306h11190v4608h-658c-364 0-659 295-659 658v6583c0 364 295 658 659 658h2633c364 0 658-294 658-658v-6583c0-363-294-658-658-658h-658v-4608h7523v9874c0 3267 2658 5925 5925 5925h14670v5266c0 2178 1771 3950 3949 3950h752c365 0 659-294 659-659V28964c0-363-295-658-659-658z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
